module.exports = __webpack_public_path__ + "static/img/login-bg.b142f8fd.jpg";